import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DEPARTMENT_TYPE_ARBITRATION } from 'src/app/core/constants';

@Component({
    selector: 'app-arbitration-attached',
    templateUrl: './arbitration-attached.component.html',
    styleUrls: ['./arbitration-attached.component.scss'],
})
export class ArbitrationAttachedComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Arbitragem
     */
    public departmentType: string = DEPARTMENT_TYPE_ARBITRATION;

    /**
     * Definição do parâmetro recebido via url através do menu sidebar
     */
    public sessionType;

    constructor(private route: ActivatedRoute) {
        this.route.params.subscribe((params) => (this.sessionType = params['sessionType']));
    }

    ngOnInit(): void {
        //console.log('sessionType=' + this.sessionType);
    }
}
